"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var React = require("react"),
    common_1 = require("./common"),
    common_2 = require("./common");

function populatePreviousSlides(state, props, slidesHavePassed) {
  void 0 === slidesHavePassed && (slidesHavePassed = 0);
  var nextSlides,
      nextPosition,
      currentSlide = state.currentSlide,
      itemWidth = state.itemWidth,
      slidesToShow = state.slidesToShow,
      children = props.children,
      showDots = props.showDots,
      infinite = props.infinite,
      slidesToSlide = common_1.getSlidesToSlide(state, props),
      nextMaximumSlides = currentSlide - slidesHavePassed - (0 < slidesHavePassed ? 0 : slidesToSlide),
      additionalSlides = (React.Children.toArray(children).length - slidesToShow) % slidesToSlide;
  return nextPosition = 0 <= nextMaximumSlides ? (nextSlides = nextMaximumSlides, showDots && !infinite && 0 < additionalSlides && common_2.isInRightEnd(state) && (nextSlides = currentSlide - additionalSlides), -itemWidth * nextSlides) : nextSlides = nextMaximumSlides < 0 && 0 !== currentSlide ? 0 : void 0, {
    nextSlides: nextSlides,
    nextPosition: nextPosition
  };
}

exports.populatePreviousSlides = populatePreviousSlides;